"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_react_1 = require("mobx-react");
const react_1 = __importStar(require("react"));
require("./index.scss");
const Select_1 = __importDefault(require("@Components/Selectors/Select"));
const Pagination_1 = __importDefault(require("@Components/Pagination"));
const user_groups_to_select_options_1 = require("@App/helpers/user-groups-to-select-options");
const contexts_1 = require("@App/contexts");
const UserPermissionsUsersTable_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissions/RightsholderUserPermissionsUsersList/UserPermissionsUsersTable"));
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const limitItems = 10;
const RightsholderUserPermissionsUsersList = () => {
    const { rightsholderUserStore, rightsholderStore, userStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [selectedGroup, setSelectedGroup] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const getPagination = (value, maybeSelectedGroup, pagination = {
        page: 1,
        limit: limitItems,
    }) => {
        if (value) {
            return Object.assign(Object.assign({}, pagination), { group: value.id });
        }
        else if (maybeSelectedGroup) {
            return Object.assign(Object.assign({}, pagination), { group: maybeSelectedGroup.id });
        }
        return pagination;
    };
    const onPaginationChange = (callBackPagination) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        const pagination = getPagination(null, selectedGroup, callBackPagination);
        yield rightsholderUserStore.loadRightsholderUsers(pagination);
        setLoading(false);
    });
    const eventGetUsers = (value) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        const pagination = getPagination(value, selectedGroup);
        yield rightsholderUserStore.loadRightsholderUsers(pagination);
        setLoading(false);
    });
    const selectGroup = (value) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        setSelectedGroup(value);
        const pagination = getPagination(value, value);
        yield rightsholderUserStore.loadRightsholderUsers(pagination);
        setLoading(false);
    });
    (0, react_1.useEffect)(() => {
        eventGetUsers().then();
    }, []);
    const currentMemberSummary = rightsholderStore.memberSummary;
    const rightsholderUsers = rightsholderUserStore.rightsholderUsers;
    const paginationPages = rightsholderUserStore.rightsHolderUsersPagination;
    const userGroups = userStore.permissionGroupsFiltered;
    const userGroupsOptions = (0, user_groups_to_select_options_1.transformUserGroupsToSelectOptions)(userGroups);
    if (!rightsholderUsers) {
        return react_1.default.createElement(PointPreloader_1.default, null);
    }
    return (react_1.default.createElement("div", { className: "rightsholder-user-permissions-users-tab" },
        react_1.default.createElement("div", { className: "search-users-block" },
            react_1.default.createElement("p", { className: 'bold small info-count' },
                react_1.default.createElement("span", { className: 'bold small' },
                    rightsholderUsers.count ? rightsholderUsers.count : 0,
                    " Users for\u00A0"),
                react_1.default.createElement("span", { title: currentMemberSummary.name, className: 'bold small' },
                    "\"",
                    currentMemberSummary.name,
                    "\"")),
            react_1.default.createElement("div", { className: "search" }, userGroupsOptions && (react_1.default.createElement(Select_1.default, { options: userGroupsOptions, onValueChange: selectGroup, activeInputState: true, placeholder: 'Select Group', isClearable: true })))),
        react_1.default.createElement("div", { className: "head-users-block" },
            react_1.default.createElement("p", null,
                selectedGroup ? selectedGroup.label : 'All',
                ": ",
                rightsholderUsers.count,
                " Users")),
        loading ? react_1.default.createElement(PointPreloader_1.default, null) : react_1.default.createElement(UserPermissionsUsersTable_1.default, { eventGetUsers: eventGetUsers }),
        rightsholderUsers.count > limitItems && (react_1.default.createElement(Pagination_1.default, { limit: limitItems, paginationPages: paginationPages, onChange: onPaginationChange }))));
};
exports.default = (0, mobx_react_1.observer)(RightsholderUserPermissionsUsersList);
